// extracted by mini-css-extract-plugin
module.exports = {"facebook_login_button":"styles_facebook_login_button__-jZWP","facebook_logo_icon":"styles_facebook_logo_icon__3bXgD"};